import type { FaireProductEntity } from "../../entity_types/product";

export const p_fxu3q5cnut: FaireProductEntity = {
  token: "p_fxu3q5cnut",
  type: "product",
  name: "Long Lace Formal Black Evening Dress",
  brandToken: "b_av43xzgdd9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f8c6cbab049599fce05009061bf921828d895169375a71cdf6ebabeeae995c10.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/91a4d8e24ad0d2c0112d21dbdaf6ff2b8db271690a6df3cc8a607304e4e471ef.jpeg",
    "https://cdn.faire.com/fastly/6992ff893ac6b1a010397e820c00dcb6c378293d06f77c26e19e429c56591bcd.webp",
    "https://cdn.faire.com/fastly/580cf251800773954ef828e11d35f92b1e883eca84aa462afc4596883bb22a21.webp",
    "https://cdn.faire.com/fastly/274a34c51bd27566de60c762381e16efa984453dd5b6503a78d59bda50d448aa.png",
    "https://cdn.faire.com/fastly/171776ad2f81e8ed750808082ba6aa6eb82aec6b33d3fe3fd8b65b2061f66f66.png",
  ],
  priceDollars: 62.35,
  description:
    "Elevate your evening look with the Long Lace Formal Black Evening Dress. Designed for timeless elegance, this gown features delicate lace detailing, short sleeves, and a classic silhouette. Perfect for any formal occasion, its sophisticated style ensures you make a stunning impression. Ideal for galas, weddings, or any night that calls for effortless glamour.\n\n\n\nFabric : Lace\nLength : Full Length\nSleeve Style : Short Sleeve\nColor : Black\nSizes : S, M, L, XL, 3XL, 4XL, 5XL\nOccasion : Formal Dresses, Homecoming Dresses\nStyle : DD1357",
  tags: [],
  msrpDollars: 124.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:39.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
